import { render, staticRenderFns } from "./chongzhiinput.vue?vue&type=template&id=68d6aa1a&"
import script from "./chongzhiinput.vue?vue&type=script&lang=js&"
export * from "./chongzhiinput.vue?vue&type=script&lang=js&"
import style0 from "./chongzhiinput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports